import React from 'react';
import {
  components,
} from 'react-select';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

type Props = {
  data: any;
  label: string;
  selectProps: any;
};

const AssignSearchOption = ({
  label,
  selectProps,
  data,
  ...restProps
}: Props) => (
  <components.Option {...selectProps} {...restProps}>
    <Flex
      align="center"
      justify="flex-start"
      spacing={8}
    >
      {data.newOne && (
        <S.PlusCircle />
      )}
      <span>
        {label}
      </span>
      {data.isPersonal && (
        <Text
          style={{ marginLeft: 'auto' }}
          color="primary"
        >
          Personal Workout
        </Text>
      )}
    </Flex>
  </components.Option>
);

export default AssignSearchOption;
